import React from "react";
import "./Industries.css";
import useScrollReveal from "../hooks/useScrollReveal";
import { HeartPulse, Sprout, Layers, Landmark } from "lucide-react";

const industries = [
  {
    name: "Healthcare",
    icon: HeartPulse,
    description:
      "HIPAA-compliant platforms, medical imaging (DICOM), telehealth applications, and patient data systems built on secure cloud infrastructure.",
  },
  {
    name: "Agriculture & IoT",
    icon: Sprout,
    description:
      "Precision farming platforms, IoT sensor networks, satellite data processing, and ML-powered crop analytics for modern agriculture.",
  },
  {
    name: "SaaS",
    icon: Layers,
    description:
      "Multi-tenant architectures, billing integrations, scalable APIs, and infrastructure that grows with your user base from hundreds to millions.",
  },
  {
    name: "FinTech",
    icon: Landmark,
    description:
      "Secure transaction processing, real-time data pipelines, regulatory compliance (PCI-DSS), and financial analytics platforms.",
  },
];

export default function Industries() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="industries reveal">
      <h1>Industries We Serve</h1>
      <p className="industries-subtitle">
        Domain expertise that goes beyond code
      </p>
      <div className="industries-grid">
        {industries.map((industry, idx) => {
          const Icon = industry.icon;
          return (
            <div
              className={`industry-card reveal-delay-${idx + 1}`}
              key={idx}
            >
              <div className="industry-card-icon">
                <Icon size={24} strokeWidth={1.5} />
              </div>
              <h3 className="industry-card-name">{industry.name}</h3>
              <p className="industry-card-desc">{industry.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
